import './ArchiveStatue.scss';
import 'Sections/BackgroundImage/BackgroundImage';
import 'Sections/PageHeading/PageHeading';
import 'Components/StatueTile/StatueTile';
ComponentManager.init(document.body);